import React from 'react'
import { groupBy } from 'lodash'
import { Tab, Tabs } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { TabContext, TabPanel } from '@mui/lab'

import { LocationDecorated, Roles } from '@shared/types'
import { usePersistedTabChange } from '@shared/hooks/use-persisted-tab-change'

import {
  CompanyActions,
  SelectLocationTable,
} from './select-location-table.component'
import { AuditModes } from './select-location.types'
import { useACL } from '@shared/hooks/use-acl.hook'
import { useAuth } from '@modules/auth/use-auth.hook'
import { Navigate } from 'react-router-dom'
import { useCompaniesEvaluationProfileQuery } from '@shared/hooks/use-companies-evaluation-profiles'

export function SelectLocationPage() {
  const classes = useStyles()
  const { currentTab, onTabChange } = usePersistedTabChange(
    'selectLocation.currentTab'
  )
  const { is } = useACL()
  const { authStatus } = useAuth()
  const isUnknownStatus = authStatus === 'unknown'

  const { companiesEvaluationProfiles, areCompaniesProfilesLoading } =
    useCompaniesEvaluationProfileQuery()

  const locationsDecorated: { [key: string]: LocationDecorated[] } = groupBy(
    (companiesEvaluationProfiles ?? []).map((company) => {
      let action: string[] = []

      if (company.ongoingAuditId !== null && !company.notConfigured) {
        action.push(CompanyActions.CONTINUE_AUDIT, CompanyActions.PREVIEW)
      } else if (company.notConfigured) {
        action.push(CompanyActions.CONFIGURE_LOCATION)
      } else if (!company.notConfigured && company.ongoingAuditId === null) {
        action.push(CompanyActions.RUN_AUDIT, CompanyActions.PREVIEW)
      }

      return {
        ...company,
        action,
      } as LocationDecorated
    }),
    (company: LocationDecorated) =>
      String(
        company.ongoingAuditId !== null && !company.notConfigured
          ? AuditModes.InProgress
          : AuditModes.Other
      )
  )

  if (!isUnknownStatus && !is([Roles.Admin, Roles.Auditor])) {
    return <Navigate to="/select-location/client" />
  }

  return (
    <TabContext value={currentTab}>
      <Tabs
        className={classes.tab}
        value={currentTab}
        onChange={onTabChange}
        variant="fullWidth"
        textColor="primary"
        indicatorColor="primary"
      >
        <Tab label={AuditModes.InProgress} value="0" />
        <Tab label={AuditModes.Other} value="1" />
      </Tabs>
      <TabPanel value="0">
        <SelectLocationTable
          mode={AuditModes.InProgress}
          isLoading={areCompaniesProfilesLoading}
          companies={locationsDecorated[AuditModes.InProgress]}
        />
      </TabPanel>
      <TabPanel value="1">
        <SelectLocationTable
          mode={AuditModes.Other}
          isLoading={areCompaniesProfilesLoading}
          companies={locationsDecorated[AuditModes.Other]}
        />
      </TabPanel>
    </TabContext>
  )
}

export const useStyles = makeStyles((theme) => {
  return {
    tab: { width: '95%', margin: '0 auto' },
  }
})
